import { Box, MultiLine } from 'components/common';

export interface PhasesProps {
  phases: { id: string; title: string; instruction?: string }[];
}

const Phases = (props: PhasesProps) => (
  <div className="quick-view__tab-body">
    {props.phases?.length > 0 &&
      props.phases.map((phase) => (
        <Box key={phase.id} mt2>
          <b>{phase.title}</b>
          <MultiLine text={phase.instruction} />
        </Box>
      ))}
  </div>
);

Phases.displayName = 'Phases';
export default Phases;
